// ── 직원 관리 한 목록: 줄 종류(4대보험 / 3.3%) · 합치기 · 정렬 (2026-11-03 미남님 "직원·마케터 합치기") ──────
//   구분은 직원/마케터가 아니라 급여 방식이다 — 4대보험(employee·external, 급여명세서·출퇴근) / 3.3%(freelancer, 정산서).
//   3.3% 판정은 utils/workerType.js 만 쓴다.
import { isFreelancerWorker } from '../../../utils/workerType';

export const KIND_ALL = 'all';
export const KIND_INSURED = 'insured';
export const KIND_FREELANCE = 'freelance';
export const KIND_LABEL = { [KIND_INSURED]: '4대보험', [KIND_FREELANCE]: '3.3%' };

export function rowKind(row) {
  return isFreelancerWorker(row?.worker_type) ? KIND_FREELANCE : KIND_INSURED;
}

// 구분 배지 — 3.3% 는 예전 '프리랜서 (정산서)' 배지 색 그대로, 4대보험은 차분한 회색
export function kindBadgeStyle(kind) {
  const freelance = kind === KIND_FREELANCE;
  return {
    display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap',
    color: freelance ? '#7c4a03' : '#374151',
    background: freelance ? '#fdf0d5' : '#e5e7eb',
  };
}

// 직원 목록(이 회사 소속) + 이 회사 담당 3.3% 목록(담당 연결·소속 폴백) → 한 사람 한 줄.
//   같은 사람이 양쪽에 있으면 담당 목록 값(담당 회사·폴백 여부)을 얹는다. fromLinks = 담당 목록에서 온 줄(담당 해제 가능 여부 판정용).
export function mergePeople(employeeRows, linkRows) {
  const byId = new Map();
  for (const row of employeeRows || []) byId.set(String(row.id), { ...row, fromLinks: false });
  for (const row of linkRows || []) {
    const key = String(row.id);
    const prev = byId.get(key);
    byId.set(key, prev ? { ...prev, ...row, department: row.department ?? prev.department, fromLinks: true } : { ...row, fromLinks: true });
  }
  return [...byId.values()];
}

// 정렬(결정 1a) — 입사일 최근순, 같으면 이름순. 입사일이 없으면 아래쪽.
export function sortPeople(rows) {
  const day = (r) => String(r.hire_date || '').slice(0, 10);
  return [...rows].sort((a, b) => {
    const da = day(a); const db = day(b);
    if (da !== db) {
      if (!da) return 1;
      if (!db) return -1;
      return da < db ? 1 : -1;
    }
    return String(a.name || '').localeCompare(String(b.name || ''), 'ko');
  });
}

// 3.3% 줄 '담당 회사' 칸 — 담당이 하나도 없으면 소속 회사로 보이는 줄(is_fallback)
export function assignedCompaniesInfo(row, companyCode) {
  if (rowKind(row) !== KIND_FREELANCE) return { text: '-', muted: true };
  if (!row.fromLinks) return { text: '-', muted: true, title: '이 회사 담당으로 지정되지 않았습니다.' };
  if (row.is_fallback) {
    return { text: '미지정 (소속 기준)', muted: true, title: '담당 회사가 아직 지정되지 않아 소속 회사로 표시됩니다. [+ 마케터 지정]으로 확정할 수 있습니다.' };
  }
  const others = (row.linked_companies || []).filter((c) => c !== companyCode);
  if (others.length === 0) return { text: '이 회사만', muted: true };
  return { text: `${others.join(', ')} 도 담당`, title: '같은 계정으로 여러 회사를 담당합니다.' };
}
